// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"PaymentEditPanel_UsersInfoPanel__l893H","buttonsPanel":"PaymentEditPanel_buttonsPanel__GOmjM"};